
















































































































































































import {
  Component, Prop, Vue, PropSync, Mixins,
} from 'vue-property-decorator';
import {
  Market, Sector, Settings, User, UserApi, Unit,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import Sticky from 'vue-sticky-directive';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import VuetifySelect from '@/components/Form/VuetifySelect/index.vue';
import { IUnitInformation } from '@/interface/unitInfo';
import MarketUtil from '@/util/MarketUtil';
import ConfigUtil from '@/util/ConfigUtil';
import Format from '@/util/Format';
import SystemModule from '@/store/modules/system';
import UserModule from '@/store/modules/user';
import UnitsUtil from '@/util/UnitUtil';
import Users from '../../Partner/RestaurantInformation/Data/State';
import PermissionMixin from '../../../../mixins/PermissionMixin';

@Component({
  components: {
    Textfield,
    VuetifySelect,
    PrimaryButton,
    TextButton,
  },
  directives: { Sticky },
})
export default class UnitInformation extends Mixins(PermissionMixin) {
  @PropSync('unitInfo', {}) unitInfoSync!: IUnitInformation;

  @PropSync('scoutUserStatus', {}) scoutUserInfo!: Unit;

  private users = Users;

  private usersList: User[] = [];

  private unitManagerList: User[] = [];

  public errors:string = '';

  public loading:boolean = false;

  public sectorsArray: Sector | null = null;

  public marketsArray: Market | null = null;

  private scoutItems: any[] = [];

  unitIdRules = [
    (v: any) => !!v || 'Unit ID is required',
    (v: any) => /^[0-9]*$/.test(v) || 'Unit ID should contain only numbers',
    (v: any) => v.toString().length <= 12 || 'Unit ID must be less than 13 digits',
  ];

  unitNameRules = [(v: any) => !!v || 'Unit Name is required'];

  unitStreetRules = [(v: any) => !!v || 'Unit Street Address is required'];

  unitCityRules = [(v: any) => !!v || 'Unit City is required'];

  unitStateRules = [(v: any) => !!v || 'Unit State is required'];

  unitZipRules = [
    (v: any) => /\d{5}?/g.test(v) || 'Pls enter 5-digit numeric value.',
  ];

  unitWorkNumberRules = [
    (mobileNumber: any) => /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g.test(mobileNumber)
     || 'Pls enter 10-digit numeric value.',
  ];

  // unitExtRules = [
  //   // (ext: any) => /^$|\d{4}?/g.test(ext) || 'Pls enter 4-digit numeric value.',
  //   (ext: any) => {
  //     if (ext && ext.length > 0 && !(/^$|\d{4}?/g.test(ext))) {
  //       return 'Pls enter 4-digit numeric value';
  //     }
  //     return true;
  //   },
  // ];

  unitSectorRules = [(v: any) => !!v || 'Unit Sector is required'];

  unitMarketRules = [(v: any) => !!v || 'Unit Market  is required'];

  unitScoutRules = [(v: any) => !!v || 'Unit Scout is required'];

  unitManagerRules = [(v: any) => !!v || 'Unit Manager is required'];

  public mounted() {
    this.getMarkets();
    this.getSectors();
  }

  public getMarkets() {
    try {
      const { sectors, markets }: any = SystemModule;
      const marketItems = MarketUtil.getMappedMarkets(markets);
      ((this.marketsArray) as any) = Format.sortedItems(marketItems);
      const sectorItems = MarketUtil.getMappedMarkets(sectors);
      ((this.sectorsArray) as any) = Format.sortedItems(sectorItems);
    } catch (err) {
      this.errors = err.error;
    }
  }

  public async getSectors() {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const api = new UserApi(AppModule.apiConfig);
          const users = await api.getUsers();
          ((this.usersList) as any) = UnitsUtil.scoutListFormatted(users.data);
          (this.unitManagerList as any) = UnitsUtil.unitManagerListFormat(users.data);
          const scoutUsers = await api.getUser(UserModule.userId);
          (this.scoutItems as any) = Format.usersFwEmployee(scoutUsers.data as any);
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  get onBoardingUnitUser() {
    if (UserModule.currentUser && UserModule.currentRole === 'unit_manager') {
      return UserModule.currentRole;
    }
    return null;
  }
}
